import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


import AreaUnit from 'src/app/shared/enums/AreaUnit.enum';
import { LpAssetReqRes } from 'src/app/lp/assets/LpAssetReqRes.model';

@Component({
  selector: 'terra-asset-details-dialog',
  templateUrl: './asset-details-dialog.component.html',
  styleUrls: ['./asset-details-dialog.component.scss']
})
export class AssetDetailsDialogComponent implements OnInit {

  // Enums
  AreaUnit = AreaUnit;

  constructor(@Inject(MAT_DIALOG_DATA) public asset: LpAssetReqRes) { }

  ngOnInit() {
  }

}
